import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const pathdummy = [
  { name: "Dashboard", path: "/dashboard", icon: "bi-speedometer2" },
  { name: "Project Review", path: "/project-review", icon: "bi-kanban" },
  { name: "Message", path: "/message", icon: "bi-envelope" },
  { name: "ID Card Access", path: "/idcard-access", icon: "bi-person-badge" },

  { name: "Analytics", path: "/analytics", icon: "bi-bar-chart-line" },
  { name: "Payroll", path: "/payroll", icon: "bi-cash-stack" },
  { name: "Announcement", path: "/announcement", icon: "bi-megaphone" },
  { name: "Warning", path: "/warning", icon: "bi-exclamation-triangle" },
  { name: "Promotion", path: "/promotion", icon: "bi-arrow-up-circle" },
  { name: "Resignation", path: "/resignation", icon: "bi-box-arrow-right" },
  { name: "Termination", path: "/termination", icon: "bi-x-circle" },

  { name: "Categories", path: "/Categories", icon: "bi-tags" },
  { name: "Budget", path: "/Budget", icon: "bi-wallet2" },
  { name: "Budget Revenue", path: "/Budget-Revenue", icon: "bi-graph-up-arrow" },
  { name: "Budget Expense", path: "/Budget-Expense", icon: "bi-graph-down-arrow" },

  { name: "Call History", path: "/call-history", icon: "bi-telephone" },
  { name: "Pipelines", path: "/pipelines", icon: "bi-diagram-3" },

  { name: "Performance Appraisal", path: "/Performance-Appraisal", icon: "bi-clipboard-data" },
  { name: "Performance Indicator", path: "/Performance-Indicator", icon: "bi-speedometer" },
  { name: "Goal Tracking", path: "/Goal-Tracking", icon: "bi-bullseye" },
  { name: "Goal Type", path: "/Goal-Type", icon: "bi-list-check" },

  { name: "Loan", path: "/Loan", icon: "bi-bank" },
  { name: "Performance Review", path: "/performance-review", icon: "bi-journal-check" },

  { name: "Referrals", path: "/referrals", icon: "bi-person-plus" },
  { name: "Notes", path: "/Notes", icon: "bi-sticky" },

  { name: "Projects", path: "/Projects", icon: "bi-folder" },
  { name: "Jobs", path: "/jobs", icon: "bi-briefcase" },
  { name: "Clients", path: "/clients", icon: "bi-people-fill" },
  { name: "Shortlist", path: "/shortlist", icon: "bi-check2-square" },

  { name: "Estimations", path: "/estimations", icon: "bi-calculator" },
  { name: "Leads", path: "/leads", icon: "bi-person-lines-fill" },
  { name: "Deals", path: "/deals", icon: "bi-briefcase" },
  { name: "Contracts", path: "/contracts", icon: "bi-file-earmark-text" },

  { name: "Assets", path: "/assets", icon: "bi-cpu" },
  { name: "Assets Category", path: "/assets-category", icon: "bi-cpu" },
  { name: "Schedule", path: "/schedule", icon: "bi-cpu" },
  { name: "Leaves", path: "/leaves", icon: "bi-cpu" },
  { name: "Attendance", path: "/attendance", icon: "bi-cpu" },
  { name: "Activity", path: "/activity", icon: "bi-cpu" },
  { name: "Holidays", path: "/holidays", icon: "bi-cpu" },
    
  // Employee
  { name: "Employee Details", path: "/employees-details", icon: "bi-people" },
  { name: "Analytics", path: "/analytics_A", icon: "bi-bar-chart-line" },
  
  { name: "Requirement Page", path: "/requirements", icon: "bi-card-checklist" },
  { name: "Employee Jobs", path: "/employee-jobs", icon: "bi-briefcase" },
  { name: "Timeline", path: "/timeline", icon: "bi-clock" },
  { name: "Todo", path: "/todo", icon: "bi-check2-square" },
  { name: "Reports", path: "/reports", icon: "bi-check2-square" },

  { name: "Task Report", path: "/reports/task", icon: "bi-list-check" },
  { name: "Daily Report", path: "/reports/daily", icon: "bi-calendar-day" },
  { name: "Project Report", path: "/reports/project", icon: "bi-kanban" },
  { name: "Payment Report", path: "/reports/payment", icon: "bi-credit-card" },
  { name: "Invoice Report", path: "/reports/invoice", icon: "bi-receipt" },
  { name: "Expense Report", path: "/reports/expense", icon: "bi-cash-stack" },
  { name: "User Report", path: "/reports/user", icon: "bi-person-lines-fill" },
  { name: "Attendance Report", path: "/reports/attendance", icon: "bi-clock-history" },
  { name: "Employee Report", path: "/reports/employee", icon: "bi-person-badge" },
  { name: "Payslip Report", path: "/reports/payslip", icon: "bi-file-earmark-text" },
  { name: "Leave Report", path: "/reports/leave", icon: "bi-calendar-x" },
  { name: "Company Report", path: "/reports/company", icon: "bi-building" },

  { name: "Settings", path: "/settings", icon: "bi-gear" },
];

function Sidebar() {
  const [menuItems, setMenuItems] = useState(pathdummy);

  return (
    <div className="d-flex flex-column h-100">
      {/* Menu */}
      <ul className="nav nav-pills flex-column gap-1 px-2 py-2">
        {menuItems.map((item, index) => (
          <li key={index} className="nav-item">
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `nav-link d-flex align-items-center gap-2 rounded px-3 py-2 
                 ${isActive ? "active bg-primary text-white" : "text-light"}`
              }
            >
              <i className={`bi ${item.icon} text-white`}></i>
              <span className="small">{item.name}</span>
            </NavLink>
          </li>
        ))}
      </ul>

      {/* Logout */}
      <div className="mt-auto px-2 pb-3">
        <NavLink
          to="/logout"
          className="nav-link d-flex align-items-center gap-2 text-danger px-3 py-2 rounded"
        >
          <i className="bi bi-box-arrow-right"></i>
          <span className="small">Logout</span>
        </NavLink>
      </div>
    </div>
  );
}

export default Sidebar;
